import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DynamicDictService {
  key: string;
  constructor() {}

  dropdownCreateNewValidator(control: FormControl) {
    const value = control.value;
    if (value != null && value === 'CREATE NEW') {
      return {
        select_aggregate_group: true,
      };
    }
    return null;
  }
}
